// extracted by mini-css-extract-plugin
export default {"Container":"Toast_Container__PxgpP","Icon":"Toast_Icon__E0KJM","Text":"Toast_Text__x6qSe"};